import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MultiInputFileComponent} from "./multi-input-file.component";
import {ButtonModule} from "../button/button.module";
import {TranslateModule} from "@ngx-translate/core";
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [ MultiInputFileComponent ],
  imports: [ CommonModule, ButtonModule, TranslateModule, MatIconModule ],
  exports: [ MultiInputFileComponent ],
})
export class MultiInputFileModule {}
